export const menuList = [
    {
        id: 1,
        name: "Нова пошта",
        links: [
            {
                name: "Список ттн",
                link: "/novaposhta/1",
                permission: "novaposhta_section",
            },
            {
                name: "Додати ттн",
                link: "/ttn",
                permission: "novaposhta_section",
            },
            // {
            //     name: "Відправки",
            //     link: "/shipments",
            // },
        ],
    },
    {
        id: 2,
        name: "Ремонти",
        links: [
            {
                name: "Всі ремонти",
                link: "/repairs",
                permission: "repair_view",
            },
            {
                name: "Додати ремонт",
                link: "/repair",
                permission: "repair_view",
            },
            ,
            // {
            //     name: 'Сервісний центр inStyle',
            //     link: '/repairs_service'
            // }
            {
                name: "Сервісний центр",
                link: "/repairs_service/0",
                permission: "repair_view",
            },
            // {
            //     name: 'Сервісний центр BuyBest',
            //     link: '/repairs_service_buybest'
            // }
        ],
    },
    {
        id: 3,
        name: "Продажі",
        links: [
            {
                name: "Всі замовлення",
                link: "/orders",
                permission: "order_view",
            },
            {
                name: "Додати замовлення",
                link: "/order",
                permission: "order_view",
            },
            {
                name: "Список Покупців",
                link: "/clients",
                permission: "client_view",
            },
            {
                name: "Запити товарів",
                link: "/requests",
                permission: "request_view",
            },
            {
                name: "Історія обмінів",
                link: "/exchanges",
                permission: "order_view",
            },
        ],
    },
    {
        id: 4,
        name: "Товари",
        links: [
            {
                name: "Список товарів",
                link: "/products",
                permission: "product_view",
            },
            {
                name: "Додати товар",
                link: "/product",
                permission: "product_view",
            },
            {
                name: "Категорія товарів",
                link: "/categories",
                permission: "category_view",
            },
            {
                name: "Моделі товарів",
                link: "/models",
                permission: "model_view",
            },
            {
                name: "Характеристики товарів",
                link: "/features/0",
                permission: "feature_view",
            },
        ],
    },
    {
        id: 5,
        name: "Звіти",
        links: [
            {
                name: "Продажі",
                link: "/reports_order",
                permission: "report_order",
            },
            // {
            //     name: "Бонуси",
            //     link: "/reports_bonuses",
            // },
            {
                name: "Залишки товарів",
                link: "/reports_products",
                permission: "report_order",
            },
            {
                name: "Ремонти",
                link: "/reports_repairs",
                permission: "report_repair",
            },
            // {
            //     name: "Залишки по моделям ВВ",
            //     link: "/reports_shipper",
            // },
            {
                name: "Залишки товарів WEB",
                link: "/reports_web",
                permission: "report_remainings_web",
            },
            // {
            //     name: "Статус синхронізації",
            //     link: "/reports_sync",
            // },
        ],
    },
    // {
    //    name: "Автоматизація",
    //    links: [
    //       {
    //          name: "Імпорт",
    //          link: "/import",
    //       },
    //       {
    //          name: "Єкспорт",
    //          link: "/export",
    //       },
    //    ],
    // },
    {
        id: 6,
        name: "Налаштування",
        links: [
            {
                name: "Магазини",
                link: "/stores/1",
                permission: "store_view",
            },
            {
                name: "Менеджери",
                link: "/managers/1",
                permission: "user_view",
            },
            {
                name: "Постачальники",
                link: "/shippers/1",
                permission: "shipper_edit",
            },
            {
                name: "Послуги",
                link: "/services/1",
                permission: "service_view",
            },
            {
                name: "Логи",
                link: "/logs",
                permission: "logs",
            },
        ],
    },
];
